import _classCallCheck from "/var/opt/court3d/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/opt/court3d/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/opt/court3d/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/opt/court3d/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/opt/court3d/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Curve, Vector3, Vector4 } from 'three';
import { NURBSUtils } from '../curves/NURBSUtils.js';
/**
 * NURBS curve object
 *
 * Derives from Curve, overriding getPoint and getTangent.
 *
 * Implementation is based on (x, y [, z=0 [, w=1]]) control points with w=weight.
 *
 **/

var NURBSCurve = /*#__PURE__*/function (_Curve) {
  _inherits(NURBSCurve, _Curve);

  var _super = _createSuper(NURBSCurve);

  function NURBSCurve(degree, knots
  /* array of reals */
  , controlPoints
  /* array of Vector(2|3|4) */
  , startKnot
  /* index in knots */
  , endKnot
  /* index in knots */
  ) {
    var _this;

    _classCallCheck(this, NURBSCurve);

    _this = _super.call(this);
    _this.degree = degree;
    _this.knots = knots;
    _this.controlPoints = []; // Used by periodic NURBS to remove hidden spans

    _this.startKnot = startKnot || 0;
    _this.endKnot = endKnot || _this.knots.length - 1;

    for (var i = 0; i < controlPoints.length; ++i) {
      // ensure Vector4 for control points
      var point = controlPoints[i];
      _this.controlPoints[i] = new Vector4(point.x, point.y, point.z, point.w);
    }

    return _this;
  }

  _createClass(NURBSCurve, [{
    key: "getPoint",
    value: function getPoint(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
      var point = optionalTarget;
      var u = this.knots[this.startKnot] + t * (this.knots[this.endKnot] - this.knots[this.startKnot]); // linear mapping t->u
      // following results in (wx, wy, wz, w) homogeneous point

      var hpoint = NURBSUtils.calcBSplinePoint(this.degree, this.knots, this.controlPoints, u);

      if (hpoint.w !== 1.0) {
        // project to 3D space: (wx, wy, wz, w) -> (x, y, z, 1)
        hpoint.divideScalar(hpoint.w);
      }

      return point.set(hpoint.x, hpoint.y, hpoint.z);
    }
  }, {
    key: "getTangent",
    value: function getTangent(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
      var tangent = optionalTarget;
      var u = this.knots[0] + t * (this.knots[this.knots.length - 1] - this.knots[0]);
      var ders = NURBSUtils.calcNURBSDerivatives(this.degree, this.knots, this.controlPoints, u, 1);
      tangent.copy(ders[1]).normalize();
      return tangent;
    }
  }]);

  return NURBSCurve;
}(Curve);

export { NURBSCurve };